var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.3862C17.25 11.925 14.415 11.5305 12.1373 11.214C9.65475 10.869 8.25 10.569 8.25 8.4315C8.25 6.6375 10.1303 6 11.7405 6C12.543 5.97383 13.3402 6.13892 14.0663 6.48163C14.7924 6.82434 15.4266 7.33485 15.9165 7.971L17.0835 7.029C16.5587 6.35413 15.9057 5.78964 15.162 5.36798C14.4183 4.94632 13.5986 4.67581 12.75 4.572V2.25H11.25V4.5165C8.53875 4.6815 6.75 6.2115 6.75 8.4315C6.75 11.979 9.6225 12.3787 11.931 12.699C14.37 13.0387 15.75 13.3305 15.75 15.3862C15.75 17.6602 13.4003 18 12 18C9.4275 18 8.3415 17.277 7.3335 16.029L6.1665 16.971C6.76115 17.7544 7.53018 18.3885 8.41258 18.8229C9.29498 19.2574 10.2665 19.4802 11.25 19.4738V21.75H12.75V19.4662C15.5445 19.2383 17.25 17.721 17.25 15.3862Z",
    fill: "#A93AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyDollar);
export default __webpack_public_path__ + "static/media/currency-dollar.80e3c2e9b6796ea6ba6cb12eb5ec26af.svg";
export { ForwardRef as ReactComponent };